@if(preClosureMessage.isVisible || startPageBanner.isVisible || bannerMessages.length > 0){
  <div class="sx-system-message__container sxl-flex sxl-column">
    @if(preClosureMessage){
      <app-system-message
          [ngClass]="{'sx-system-message__notLoggedIn': !isLoggedIn}"
          [id]="preClosureMessage.id"
          [isVisible]="preClosureMessage.isVisible" 
          [severity]="preClosureMessage.severity" 
          [icon]="preClosureMessage.icon" 
          [isDismissable]="isLoggedIn" 
          (messageDismissed)="onMessageDismissed($event)">
          
          <div [innerHtml]="preClosureMessage.content | safeHtml"></div>
      </app-system-message>
    }

    @if(!isLoggedIn && startPageBanner){
      <app-system-message
        [ngClass]="{'sx-system-message__notLoggedIn': !isLoggedIn}"
        [id]="startPageBanner.id"
        [isVisible]="startPageBanner.isVisible" 
        [severity]="startPageBanner.severity" 
        [icon]="startPageBanner.icon" 
        [isDismissable]="false" 
        (messageDismissed)="onMessageDismissed($event)">
    
        <div [innerHtml]="startPageBanner.content | safeHtml"></div>
      </app-system-message>
    }

    @if(isLoggedIn){
      <span [ngClass]="{'sx-system-message__container-list': !allMessagesDismissed}">
        @for(message of bannerMessages; track message.id){
          <app-system-message
              [id]="message.id"
              [isVisible]="message.isVisible" 
              [severity]="message.severity" 
              [icon]="message.icon" 
              [isDismissable]="true"
              (messageDismissed)="onMessageDismissed($event)">
            
              <div [innerHtml]="message.content | safeHtml"></div>
          </app-system-message>
        }
      </span>
    }
  </div>
}
